import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useStudent } from '../../context/StudentContext';
import { LoadingScreen } from './LoadingScreen';
import type { UserRole } from '@kids-ai/shared-types';

interface ProtectedRouteProps {
  /** Require the authenticated user to have this role (or 'admin'). */
  role?: UserRole;
  /** Require an active child to be selected — bounces to /child-select if not. */
  requireChild?: boolean;
  /** Require parent PIN to have been verified this session — bounces to /child-select. */
  requireParentPin?: boolean;
}

export function ProtectedRoute({ role, requireChild, requireParentPin }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, hasRole } = useAuth();
  const { activeChild, isLoading: studentLoading, parentPinVerified } = useStudent();

  if (isLoading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role && !hasRole(role, 'admin')) return <Navigate to="/dashboard" replace />;

  if (requireParentPin && !studentLoading && !parentPinVerified) {
    return <Navigate to="/child-select" replace />;
  }

  if (requireChild && !studentLoading && !activeChild) {
    return <Navigate to="/child-select" replace />;
  }

  return <Outlet />;
}
